var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('b-row',{staticClass:"no-gutters"},[_c('b-col',{staticClass:"d-flex justify-content-end shadow p-3"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.addSpacePlanClicked}},[_vm._v("\n        "+_vm._s(_vm._f("capitalize")(_vm.$t('add-vizualization')))+"\n      ")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }